<div class="bn-manage-goals-dialog flex flex-col gap-4">
  <header class="bn-manage-goals-dialog__header">
    <h2 class="bn-manage-goals-dialog__title m-0">Client goals</h2>
  </header>

  <fieldset
    class="border-0 p-0 m-0 min-w-0 flex flex-col gap-4"
    [disabled]="saving() || liveSaveStarted()"
  >
    @if (editingGoalId(); as editingId) {
      <div class="bn-manage-goals-dialog__editor flex flex-col gap-2">
        <textarea
          pTextarea
          rows="2"
          maxlength="200"
          aria-label="Edit goal"
          [ngModel]="editDraft()"
          (ngModelChange)="editDraft.set($event)"
        ></textarea>
        <div class="flex items-center justify-end gap-3">
          <button
            type="button"
            class="bn-manage-goals-dialog__action"
            (click)="cancelEdit()"
          >
            Cancel
          </button>
          <p-button
            label="Save"
            [rounded]="true"
            (onClick)="commitEdit(editingId)"
          />
        </div>
      </div>
    }

    @if (workingGoals().length === 0) {
      <p class="text-sm text-surface-500 m-0">No active goals yet.</p>
    } @else {
      <ul class="bn-manage-goals-dialog__list flex flex-col list-none m-0 p-0">
        @for (goal of workingGoals(); track goal.id; let i = $index) {
          @if (editingGoalId() !== goal.id) {
            <!-- dragHandle is matched against the raw mousedown target with Element.matches,
               so it has to cover the grip's icons too or pressing a dot cancels the drag. -->
            <li
              class="bn-manage-goals-dialog__row flex items-center gap-3"
              [class.bn-manage-goals-dialog__row--marked]="goal.mark !== null"
              [class.bn-manage-goals-dialog__row--dragging]="
                draggingIndex() === i
              "
              pDraggable="care-plan-goals"
              dragHandle=".bn-manage-goals-dialog__handle, .bn-manage-goals-dialog__handle *"
              pDroppable="care-plan-goals"
              (onDragStart)="onDragStart(i)"
              (onDragEnd)="onDragEnd()"
              (onDrop)="onDrop(i)"
            >
              <span
                class="bn-manage-goals-dialog__handle"
                role="button"
                tabindex="0"
                [attr.aria-label]="
                  'Reorder ' +
                  goal.displayText +
                  '. Use the up and down arrow keys.'
                "
                (keydown.arrowup)="moveUp(i); $event.preventDefault()"
                (keydown.arrowdown)="moveDown(i); $event.preventDefault()"
              >
                <i class="pi pi-ellipsis-v" aria-hidden="true"></i>
                <i class="pi pi-ellipsis-v" aria-hidden="true"></i>
              </span>

              <div class="flex-1 flex flex-col gap-1">
                <span class="bn-manage-goals-dialog__text">
                  {{ goal.displayText }}
                  @if (goal.mark === 'complete') {
                    <span class="bn-manage-goals-dialog__badge">Completed</span>
                  } @else if (goal.mark === 'remove') {
                    <span class="bn-manage-goals-dialog__badge"
                      >No longer relevant</span
                    >
                  }
                </span>
                <span class="bn-manage-goals-dialog__count">
                  {{ goal.linkedCaseCount }}
                  {{ goal.linkedCaseCount === 1 ? 'case' : 'cases' }} advancing
                  it
                </span>
              </div>

              @if (goal.mark === null) {
                <div class="flex items-center gap-3">
                  <button
                    type="button"
                    class="bn-manage-goals-dialog__action"
                    (click)="startEdit(goal)"
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    class="bn-manage-goals-dialog__action bn-manage-goals-dialog__action--complete"
                    (click)="markComplete(goal.id)"
                  >
                    Complete
                  </button>
                  <button
                    type="button"
                    class="bn-manage-goals-dialog__action bn-manage-goals-dialog__action--remove"
                    (click)="markRemove(goal.id)"
                  >
                    Remove
                  </button>
                </div>
              }
            </li>
          }
        }
      </ul>
    }

    @for (text of draftGoals(); track $index; let i = $index) {
      <div class="bn-manage-goals-dialog__draft flex items-start gap-2">
        <textarea
          pTextarea
          rows="2"
          maxlength="200"
          placeholder="What the client actually wants, in their words"
          [attr.aria-label]="'New goal ' + (i + 1)"
          [ngModel]="text"
          (ngModelChange)="setDraftText(i, $event)"
        ></textarea>
        <button
          type="button"
          class="bn-manage-goals-dialog__action"
          (click)="removeDraftRow(i)"
        >
          Remove
        </button>
      </div>
    }

    @if (!atCap()) {
      <button
        type="button"
        class="bn-manage-goals-dialog__add"
        (click)="addDraftRow()"
      >
        + {{ draftGoals().length > 0 ? 'Add another goal' : 'Capture goal' }}
      </button>
    }
  </fieldset>
  @if (saveError(); as message) {
    <p role="alert" class="text-sm m-0">{{ message }}</p>
  }
  <footer class="flex items-center justify-end gap-3">
    <button
      type="button"
      class="bn-manage-goals-dialog__action"
      (click)="tryClose()"
    >
      Cancel
    </button>
    <p-button
      label="Save"
      [rounded]="true"
      [loading]="saving()"
      [disabled]="
        saving() ||
        ambiguousCreate() ||
        !!editingGoalId() ||
        (store.isLive() && !store.canManageGoals())
      "
      (onClick)="save()"
    />
  </footer>
</div>

<p-confirmDialog />
